import React from 'react'
import { get } from 'lodash';
import PropTypes from 'prop-types';

function FeeInformation({ data }) {
  return (
    <table className="transaction-table table table-borderless table-sm">
      <tbody>
        <tr>
          <td className="text-dark" width="150">
            Description
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td colSpan={4}>
            <b>
              {get(data, `description`) || '-'}
            </b>
          </td>
        </tr>
        <tr>
          <td className="text-dark" width="150">
            Amount
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td colSpan={4}>
            <b>
              {get(data, `amount_human`) || '-'}
            </b>
          </td>
        </tr>
        <tr>
          <td className="text-dark" width="150">
            Discount
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td colSpan={4}>
            <b>
              {get(data, `disount_human`) || '-'}
            </b>
          </td>
        </tr>
        <tr>
          <td className="text-dark" width="150">
            Penalty
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td colSpan={4}>
            <b>
              {get(data, `penalty_human`) || '-'}
            </b>
          </td>
        </tr>
        <tr>
          <td className="text-dark" width="150">
            Total Amount
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td colSpan={4}>
            <b className="text-success">
              {get(data, `total_human`) || '-'}
            </b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

FeeInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired
}

export default FeeInformation
